import { palette } from '$tablet-app/src/app/theme';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React, { FC } from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';
import Text from '../Text';
import { TextProps } from '../Text/Text.props';

export interface ChipProps extends TextProps {
  iconLeft?: IconProp;
  iconRight?: IconProp;
  color?: string;
  textColor?: string;
  border?: string;
  chipVariant?: 'grey' | 'active';
}

const variantStyles = {
  grey: {
    container: `background-color: rgba(0, 0, 0, 0.1);  border: 2px solid rgba(0, 0, 0, 0.1);`,
    text: `color: ${palette.neutral_90};`,
    icon: palette.neutral_90,
  },

  active: {
    container: `background-color: rgba(47, 57, 238, 0.1); border: 2px solid rgba(47, 57, 238, 0.1);`,
    text: `color: ${palette.primary_90};`,
    icon: palette.primary_90,
  },
};

const Chip: FC<ChipProps> = ({ iconLeft, iconRight, ...props }) => (
  <ChipWrapper {...props}>
    {iconLeft ? (
      <FontAwesomeIcon
        icon={iconLeft}
        color={variantStyles[props.chipVariant || 'grey'].icon}
      />
    ) : null}

    <ChipText {...props} variant="caption" weight="semibold" />

    {iconRight ? (
      <FontAwesomeIcon
        icon={iconRight}
        color={variantStyles[props.chipVariant || 'grey'].icon}
      />
    ) : null}
  </ChipWrapper>
);

const ChipWrapper = styled(View)<ChipProps>`
  flex-direction: row;
  padding: 10px 16px;
  border-radius: 20px;
  align-items: center;
  gap: 8px;

  ${({ border, color, chipVariant }: ChipProps) => `
    ${chipVariant ? variantStyles[chipVariant].container : ''}
    ${color ? `background-color: ${color};` : ''}
    ${border ? `border: ${border};` : 'border: 2px solid white'}

  `}
`;

const ChipText = styled(Text)<ChipProps>`
  ${({ textColor, chipVariant }: ChipProps) => `
    ${chipVariant ? variantStyles[chipVariant].text : ''}
    ${textColor ? `color: ${textColor};` : ''}
  `}
`;

export default Chip;
